import { Folder } from "types/qbank/folder";
import FolderItem from "./FolderItem";
import SearchBar from "./SearchBar";
import { useState, useCallback } from "react";

const ensureArray = <T,>(input: T | T[]): T[] => {
    return Array.isArray(input) ? input : [input];
};

const filterItems = (items: Folder[], keyword: string): Folder[] => {
    const lowerKeyword = keyword.toLowerCase();

    return items
        .map((folder) => {
            const matchesSelf = folder.name.toLowerCase().includes(lowerKeyword);
            const filteredSubFolders = filterItems(folder.subFolders, keyword);

            if (matchesSelf || filteredSubFolders.length > 0) {
                // If self matches or any subfolder matches, include self
                return {
                    ...folder,
                    subFolders: filteredSubFolders.length > 0 ? filteredSubFolders : folder.subFolders,
                };
            }

            return null;
        })
        .filter((folder): folder is Folder => folder !== null);
};

const getItemCount = (treeArray: Folder[]): number => {
    let count = 0;
    treeArray = ensureArray(treeArray);
    for (const tree of treeArray) {
        count += 1;
        if (tree.subFolders && tree.subFolders.length > 0) {
            for (const subFolder of tree.subFolders) {
                count += getItemCount([subFolder]);
            }
        }
    }
    return count;
};

export default function FolderList(props: {
    close: () => void;
    folders: Folder[];
}) {
    const {
        folders,
        close,
    } = props;
    const [filteredFolderList, setFilteredFolderList] = useState<Folder[]>(Array.isArray(folders) ? folders : [folders]);
    const [keywordList, setKeywordList] = useState<string>("");

    const filter = useCallback((keyword: string) => {
        const filteredList = filterItems(folders, keyword);
        setFilteredFolderList(filteredList);
        setKeywordList(keyword);
    }, [folders]);

    const removeSearchItem = useCallback(() => {
        setFilteredFolderList(folders);
        setKeywordList("");
    }, [folders]);

    return (
        <>
            {getItemCount(folders) >= 20 && (
                <div className="search-bar-container">
                    <SearchBar
                        filter={filter}
                        removeSearchItem={removeSearchItem}
                        keywordList={keywordList}
                        type="Folder"
                    />
                </div>
            )}
            {filteredFolderList && (
                filteredFolderList.map(folder => (
                    <FolderItem key={folder.id} folder={folder} padding={15} close={close} />
                ))
            )}
            {!filteredFolderList && (
                folders.map(folder => (
                    <FolderItem key={folder.id} folder={folder} padding={15} close={close} />
                ))
            )}
        </>
    );
}